<template>
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9928 5.90704C11.9928 9.73275 7.07404 13.0119 7.07404 13.0119C7.07404 13.0119 2.15527 9.73275 2.15527 5.90704C2.15527 4.60251 2.6735 3.3514 3.59595 2.42895C4.51839 1.50651 5.7695 0.988281 7.07404 0.988281C8.37857 0.988281 9.62968 1.50651 10.5521 2.42895C11.4746 3.3514 11.9928 4.60251 11.9928 5.90704Z"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.07404 7.54663C7.97955 7.54663 8.71362 6.81256 8.71362 5.90704C8.71362 5.00152 7.97955 4.26746 7.07404 4.26746C6.16852 4.26746 5.43445 5.00152 5.43445 5.90704C5.43445 6.81256 6.16852 7.54663 7.07404 7.54663Z"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
